import { debug } from "./debugLogger";
/**
 * Sanitizes a filename to be URL-safe and normalized.
 * - Lowercases the name
 * - Replaces spaces with hyphens
 * - Removes non-alphanumeric characters (keeps hyphens and dots)
 * - Adds a timestamp to prevent collisions
 * 
 * @param fileName The original filename (e.g. "My Cool Image @ 2024.png")
 * @returns The sanitized filename (e.g. "my-cool-image-2024-1711812345.png")
 */
export function sanitizeFileName(fileName: string): string {
    if (!fileName) return `file-${Date.now()}`;

    // 1. Separate name and extension
    const lastDotIndex = fileName.lastIndexOf('.');
    let name = lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
    const extension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : '';

    // 2. Normalize Name
    const sanitizedName = name
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/gi, '') // Remove non-alphanumeric except hyphens
        .replace(/-+/g, '-') // Collapse multiple hyphens
        .replace(/^-+|-+$/g, ''); // Trim hyphens from start/end

    // 3. Append timestamp and unique ID
    const timestamp = Date.now();
    const uniqueId = Math.random().toString(36).substring(2, 8);
    const finalName = `${sanitizedName || 'media'}-${timestamp}-${uniqueId}${extension}`;

    debug.log(`[Sanitize] Original: "${fileName}" -> Sanitized: "${finalName}"`);
    
    return finalName;
}
